import { render } from "./Step2.vue?vue&type=template&id=86b8d3e0&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"

import "./tailwind.css?vue&type=style&index=0&id=86b8d3e0&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b8d3e0"]])

export default __exports__